import { formatParticipantDay } from './adapters/campaignParticipantsAdapter'

export const formatExtendDeadlineToast = (result = {}, { name, deadline } = {}) => {
  const extended = result.extended ?? 0
  const until = formatParticipantDay(deadline)
  if (extended === 1 && name && until) {
    return `Deadline for ${name} extended to ${until}.`
  }
  if (extended === 1 && until) {
    return `Deadline for 1 participant extended to ${until}.`
  }
  if (extended === 1 && name) {
    return `Deadline for ${name} extended.`
  }
  if (extended === 1) {
    return 'Deadline for 1 participant extended.'
  }
  if (extended > 1 && until) {
    return `Deadline for ${extended} participants extended to ${until}.`
  }
  if (extended > 1) {
    return `Deadline for ${extended} participants extended.`
  }
  return 'No participant deadlines were extended.'
}
